import type { PriceType, ProductPrices } from '../types';

export function getLowestPrice(productPrices: ProductPrices | undefined): PriceType | undefined {
    if (!productPrices || productPrices.length === 0) {
        return undefined;
    }

    return productPrices.reduce((lowest: PriceType | undefined, current) => {
        if (!lowest || current.listPrice.taxed < lowest.listPrice.taxed) {
            return {
                currency: current.currency,
                listPrice: {
                    taxed: current.listPrice.taxed,
                    untaxed: current.listPrice.untaxed,
                },
            };
        }
        return lowest;
    }, undefined);
}
